import { normalizeInterestKey } from '../Content/interestKey';

type BrevoInterestTag = {
  id: string;
  interestKey?: string | null;
  hubspotTag?: string | null;
};

export const buildBrevoInterestAttributes = ({
  tags,
  selectedTagIds,
}: {
  tags: BrevoInterestTag[];
  selectedTagIds: string[];
}) => {
  const selectedIds = new Set(selectedTagIds);

  return tags.reduce<Record<string, boolean>>((attributes, tag) => {
    const key = normalizeInterestKey(tag.interestKey || tag.hubspotTag || '');
    if (!key) return attributes;

    attributes[key] = selectedIds.has(tag.id);
    return attributes;
  }, {});
};
